/**
 * Calculate maturity score based on policy status (Universal version)
 * @param {number} policystatus - The policy status value
 * @returns {number|null} - Maturity score or null for "Not Applicable"
 */
(function($) {
	function calculateMaturityScore(policystatus) {
		// Handle different framework requirements
		if (policystatus === 0) return 0; // Not Answered
		if (policystatus === 1) return null; // Not Applicable - return null for all frameworks
		if (policystatus === 2) return 0; // Not Implemented
		else if (policystatus === 3) return 0.25;
		else if (policystatus === 4) return 0.5;
		else if (policystatus === 5) return 0.75;
		else if (policystatus === 6) return 1;
		return 0; // Default case if the policystatus is out of expected range
	}

	// Export for use in other modules
	if (typeof module !== 'undefined' && module.exports) {
		module.exports = calculateMaturityScore;
	} else if (typeof window !== 'undefined') {
		window.calculateMaturityScore = calculateMaturityScore;
	}
})(jQuery);
